export default {
  name: 'global',
  store() {
    return {
      isMobileMenuVisible: false,
      isMinicartVisible: false,
      isPredictiveSearchVisible: false,
      isAccountPopupVisible: false,
      isCurrencyMenuVisible: false,
      isWindowScrolled: false,
      isHeaderHovered: false,
      cart: null,
      init() {
        window.addEventListener('scroll', this.onWindowScrollHandler.bind(this));
        window.addEventListener('keydown', this.onKeyDownHandler.bind(this));
        this.initHeaderHoverDetection();
        window.addEventListener('mobile-menu-open', this.openMobileMenu);
        window.addEventListener('mobile-menu-closed', this.closeMobileMenu);
        window.addEventListener('toggle-search', this.toggleSearch);
        window.addEventListener('open-search', this.openSearch);
        window.addEventListener('close-search', this.closeSearch);
        document.body.addEventListener('click', (event) => {
          // Close minicart when clicking outside
          if (this.isMinicartVisible) {
            this.isMinicartVisible = false;
            document.body.classList.remove('no-scroll');
          }

          // Close search when clicking outside
          if (this.isPredictiveSearchVisible) {
            // Check if the click is outside the search area
            const searchContainer =
              event.target.closest('[data-search-container]') ||
              event.target.closest('.search-header') ||
              event.target.closest('[data-search-input]') ||
              event.target.closest('.search-overlay');

            // If click is not within search area, close search
            if (!searchContainer) {
              this.isPredictiveSearchVisible = false;
              document.body.classList.remove('search-visible');
            }
          }
        });
        window.addEventListener('toggle-minicart', this.toggleMinicart.bind(this));
        window.addEventListener('toggle-account-popup', this.toggleAccountPopup.bind(this));
        window.addEventListener('toggle-currency-menu', this.toggleCurrencyMenu.bind(this));
        this.initLiquidAJaxCart();
      },
      get bodyClasses() {
        let classes = [];

        if (this.isMobileMenuVisible) {
          classes.push('mobile-menu-visible');
        }
        if (this.isMinicartVisible) {
          classes.push('minicart-open');
        }
        if (this.isPredictiveSearchVisible) {
          classes.push('search-open');
        }

        document.body.classList[this.isMinicartVisible ? 'add' : 'remove']('no-scroll');

        return classes || '';
      },
      openMobileMenu() {
        this.isMobileMenuVisible = true;
        document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('mobile-menu-visible');
      },
      closeMobileMenu() {
        this.isMobileMenuVisible = false;
        document.body.classList[this.isMobileMenuVisible ? 'add' : 'remove']('mobile-menu-visible');
      },
      toggleSearch() {
        this.isPredictiveSearchVisible = !this.isPredictiveSearchVisible;
        document.body.classList[this.isPredictiveSearchVisible ? 'add' : 'remove']('search-visible');
      },
      openSearch() {
        this.isPredictiveSearchVisible = true;
        document.body.classList.add('search-visible');
      },
      closeSearch() {
        this.isPredictiveSearchVisible = false;
        document.body.classList.remove('search-visible');
      },
      toggleMobileMenu() {
        this.isMobileMenuVisible = !this.isMobileMenuVisible;
        this.isPredictiveSearchVisible = !this.isPredictiveSearchVisible;
      },
      toggleAccountPopup() {
        this.isAccountPopupVisible = !this.isAccountPopupVisible;
        console.log('Toggle Account Popup', this.isAccountPopupVisible);
        // document.body.classList[this.isAccountPopupVisible ? "add" : "remove"](
        //   "no-scroll",
        // );
      },
      toggleCurrencyMenu() {
        this.isCurrencyMenuVisible = !this.isCurrencyMenuVisible;
        console.log('Toggle Currency Menu', this.isCurrencyMenuVisible);
        // document.body.classList[this.isCurrencyMenuVisible ? "add" : "remove"](
        //   "no-scroll",
        // );
      },
      toggleMinicart() {
        this.isMinicartVisible = !this.isMinicartVisible;
        console.log('Toggle Minicart', this.isMinicartVisible);
        document.body.classList[this.isMinicartVisible ? 'add' : 'remove']('no-scroll');

        document.dispatchEvent(
          new CustomEvent('toggle-minicart', {
            detail: {
              isMinicartVisible: this.isMinicartVisible
            }
          })
        );
      },
      closeMinicart() {
        this.isMinicartVisible = false;
        document.body.classList.remove('no-scroll');
      },

      initLiquidAJaxCart() {
        document.addEventListener('liquid-ajax-cart:request-end', (event) => {
          const { requestState, cart, previousCart, sections } = event.detail;

          if (requestState.requestType === 'add') {
            if (requestState.responseData?.ok) {
              this.isMinicartVisible = true;
              document.body.classList.add('no-scroll');
            }
          }

          this.cart = cart;
        });
      },
      onWindowScrollHandler() {
        const isScrolled = window.scrollY > 0;

        this.isWindowScrolled = isScrolled;
        document.body.classList[isScrolled ? 'add' : 'remove']('scrolled');
      },
      initHeaderHoverDetection() {
        const headerSelectors = ['.transparent-header', 'header'];
        function isHeaderElement(element) {
          while (element && element !== document) {
            if (headerSelectors.some((selector) => element.matches && element.matches(selector))) {
              return true;
            }
            element = element.parentElement;
          }
          return false;
        }
        document.addEventListener('mouseover', (event) => {
          if (isHeaderElement(event.target)) {
            this.isHeaderHovered = true;
            document.body.classList.add('header-hovered');
          }
        });
        document.addEventListener('mouseout', (event) => {
          if (isHeaderElement(event.target)) {
            this.isHeaderHovered = false;
            document.body.classList.remove('header-hovered');
          }
        });
      },
      onKeyDownHandler(event) {
        if (event.key === 'Escape') {
          this.isMinicartVisible = false;
          this.isPredictiveSearchVisible = false;

          window.dispatchEvent(new CustomEvent('boost-sd-close-isw'));
        }
      }
    };
  }
};
